// import s from "./circularProgressBar.module.css";

import {useCircularProgressBar} from "./useCircularProgressBar";

const CircularProgressBar = (props) => {
    // Destructured props
    const {
        currentStep,
        maxSteps
    } = props;

    // Component logic data
    const componentProps = useCircularProgressBar({
        currentStep,
        maxSteps
    });

    // Destructured component logic data
    const {circleRef} = componentProps;

    return (
        <div className={`circular-progress-bar wrapper pointer-events-none select-none`}>
            <div className={`outer`}>
                <div className={`inner`}>
                    <div className={`number`}>
                        {currentStep} de {maxSteps}
                    </div>
                </div>
            </div>

            <svg
                width={`64px`}
                height={`64px`}
            >
                <defs>
                    <linearGradient id={`linearGradient`}>
                        <stop
                            offset="0%"
                            stopColor="#27AE60"
                        />
                        <stop
                            offset="100%"
                            stopColor="#27AE60"
                        />
                    </linearGradient>
                </defs>
                <circle
                    ref={circleRef}
                    cx={`32`}
                    cy={`32`}
                    r={`28`}
                />
            </svg>
        </div>
    )
}

export default CircularProgressBar;
